import { render, staticRenderFns } from "./AIAgent.MessageAssetCreated.vue?vue&type=template&id=3b35d03e&lang=pug"
import script from "./AIAgent.MessageAssetCreated.vue?vue&type=script&lang=js"
export * from "./AIAgent.MessageAssetCreated.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.MessageAssetCreated.vue?vue&type=style&index=0&id=3b35d03e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports